import { render, staticRenderFns } from "./WizardChooseGender.vue?vue&type=template&id=7a475696&scoped=true&"
import script from "./WizardChooseGender.vue?vue&type=script&lang=js&"
export * from "./WizardChooseGender.vue?vue&type=script&lang=js&"
import style0 from "./WizardChooseGender.vue?vue&type=style&index=0&id=7a475696&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a475696",
  null
  
)

export default component.exports